export default {
  expanderBackgroundColor: 'brandOne10',
  darkIcon: false,
};
